import readings from './molMosterdRows.json';
import type { BuildContext } from '../../types';
import type { PolygonIndex } from '../../../geo/polygonIndex';
import type { ReservedFootprint } from '../types';
import { obliqueRowLots, type ObliqueRow } from './obliqueRowLots';

export const MOL_MOSTERD_ROWS = readings.rows as unknown as readonly ObliqueRow[];

/** The retained lanes locate this comparison area; they do not recover medieval parcel edges. */
export function molMosterdReservation(layout: BuildContext['layout']): ReservedFootprint | null {
  const find = (id: string) => layout.streets.find((s) => s.id === id)?.centerline;
  const mol = find('street-molsteeg'),
    mosterd = find('street-mosterdpotsteeg');
  if (
    !mol ||
    !mosterd ||
    !find('quay-nieuwezijds-voorburgwal-4') ||
    !find('quay-nieuwezijds-achterburgwal')
  )
    return null;
  return {
    id: 'surveyed-mol-mosterd',
    polygon: { outer: [...mol, ...mosterd], holes: [] },
  };
}

export function planMolMosterd(
  ctx: Pick<BuildContext, 'layout' | 'site'>,
  buildable: PolygonIndex,
  reserved: readonly ReservedFootprint[]
) {
  const block = molMosterdReservation(ctx.layout);
  if (!block) return { lots: [], reserved: [], unresolved: [] };
  const lots = obliqueRowLots(MOL_MOSTERD_ROWS, ctx.layout, buildable, reserved, 53_000);
  const built = new Set(lots.map((l) => l.reconstruction!.id));
  const unresolved = MOL_MOSTERD_ROWS.flatMap((r) =>
    r.houses.flatMap((h) => h.plots?.map((p) => p.id) ?? [h.id]).filter((id) => !built.has(id))
  );
  const footprints = lots.map((l): ReservedFootprint => ({
    id: `surveyed:${l.reconstruction!.id}`,
    polygon: { outer: [...l.corners], holes: [] },
  }));
  return { lots, reserved: [block, ...footprints], unresolved };
}
